import { useEffect, useState } from 'react';
import { isClient } from '@ids/helpers';

const USER_PREFERS_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const usePrefersReducedMotion = () => {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(
        () => isClient() && window.matchMedia(USER_PREFERS_REDUCED_MOTION_QUERY).matches
    );

    useEffect(() => {
        const mediaQueryList = window.matchMedia(USER_PREFERS_REDUCED_MOTION_QUERY);

        setPrefersReducedMotion(mediaQueryList.matches);

        const listener = (event: MediaQueryListEvent) => {
            setPrefersReducedMotion(event.matches);
        };

        try {
            mediaQueryList.addEventListener('change', listener);
        } catch (err) {
            mediaQueryList.addListener(listener);
        }

        return () => {
            try {
                mediaQueryList.removeEventListener('change', listener);
            } catch (err) {
                mediaQueryList.removeListener(listener);
            }
        };
    }, []);

    return prefersReducedMotion;
};

export default usePrefersReducedMotion;
